import React from 'react'
import styled from 'styled-components'
import ThumbsviewNav from './ThumbsViewNav'

const Layout = ({
  rightNavbarMinified,
  setRightNavbarMinified,
  thumbsviewNavbarMinified,
  setthumbsviewNavbarMinified,
}) => {
  return (
    <Wrapper>
      <ThumbsviewNav
        thumbsviewNavbarMinified={thumbsviewNavbarMinified}
        setthumbsviewNavbarMinified={setthumbsviewNavbarMinified}
      />
      <BlendDiv marginLeft={thumbsviewNavbarMinified ? '111px' : '250px'} />
    </Wrapper>
  )
}

export default Layout

const BlendDiv = styled.div`
  pointer-events: none;
  position: fixed;
  margin-left: ${({ marginLeft }) => marginLeft};
  width: 33px;
  height: 100vh;
  opacity: 0.25;
  mix-blend-mode: multiply;
  transition: margin 0.5s;
  background-image: linear-gradient(
    to right,
    #000 9%,
    rgba(255, 255, 255, 0) 74%
  );
`

const Wrapper = styled.div`
  width: ${(props) => props.width};
  margin: 0 0 0 99px;
  /* background-color: #123456; */
  /* position: absolute; */
  /* right: 0px; */
  /* position */

  display: flex;
  flex-direction: row;
  transition: width 0.5s;
  /* opacity:0; */
`
